import {createSelector} from "@reduxjs/toolkit";
import {isNumber} from "lodash";
import {
	getFanVoteHistory,
	getFanVotePlayerId,
	getIsAllVotePicked,
	getIsLoadingFanVote,
	getIsLoadingPlayers,
	getIsLoadingSquads,
	getIsOpenDontLoseTeamModal,
	getPlayerById,
} from "modules/selectors";
import {IPlayer} from "modules/types";
import {IS_RELOAD_BLOCK_DISABLED} from "modules/constants";

export const getFanVotePlayer = createSelector(
	getFanVotePlayerId,
	getPlayerById,
	(playerId, selector) => selector(playerId)
);

export const getFanVotePlayers = createSelector(
	getFanVoteHistory,
	getPlayerById,
	(history, selector) =>
		history.map(({player}) => selector(player)).filter((player) => player) as IPlayer[]
);

export const getIsBlockingFanVotePage = createSelector(
	getFanVotePlayerId,
	getIsOpenDontLoseTeamModal,
	getIsAllVotePicked,
	(playerId, isOpenDontLoseTeamModal, isAllVotePicked) => {
		if (isOpenDontLoseTeamModal || isAllVotePicked) {
			return false;
		}

		return isNumber(playerId) && !IS_RELOAD_BLOCK_DISABLED;
	}
);

export const getIsLoadingFanVotePage = createSelector(
	getIsLoadingPlayers,
	getIsLoadingSquads,
	getIsLoadingFanVote,
	(isLoadingPlayers, isLoadingSquads, isLoadingFanVote) =>
		isLoadingPlayers || isLoadingSquads || isLoadingFanVote
);
